import { render } from "./StaffTrainingProgressSummary.vue?vue&type=template&id=f4806b50&scoped=true"
import script from "./StaffTrainingProgressSummary.vue?vue&type=script&lang=js"
export * from "./StaffTrainingProgressSummary.vue?vue&type=script&lang=js"

import "./StaffTrainingProgressSummary.vue?vue&type=style&index=0&id=f4806b50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4806b50"]])

export default __exports__